angular.module('bmsApp.global')
	.factory('ManualRouteSvc', [
		'$modal',
		'CRUDSvc',
		function ($modal,
				  CRUDSvc) {

			function save(manualRoute) {
				return CRUDSvc.post('api/manual-route/save', manualRoute);
			}

			function displayManualRouteModal(manualRoute) {
				var modalInstance = $modal.open({
					animation: true,
					templateUrl: 'ng/global/routes/templates/ManualRouteModal.html',
					controller: 'ManualRouteModalCtrl',
					size: 'full',
					backdrop: 'static', // disable click-outside closing modal
					windowClass: 'FOO',
					resolve: {
						manualRoute: function () {
							return manualRoute;
						}
					}
				});

				return modalInstance.result;
			}

			return {
				save: save,
				displayManualRouteModal: displayManualRouteModal
			};

		}
	]);
